import React from 'react';

function ContactSection() {
  return (
    <section id="contact" className="contact">
      <h2>Conectemos</h2>
      <p>La literatura infantil tiene el poder de transformar vidas.</p>

      <div className="social-media">
        <a href="https://www.linkedin.com/in/inmaculada-fuentes-tom%C3%A1s-08154765/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
          <div className="social-icon linkedin-icon"></div>
          <span>LinkedIn</span>
        </a>
        <a href="https://www.facebook.com/mimadreuniverse/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
          <div className="social-icon facebook-icon"></div>
          <span>Facebook</span>
        </a>
        <a href="https://www.instagram.com/mimadreuniverse/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
          <img src="/instagram_icon2.webp" alt="Instagram" className="social-icon instagram-img" />
          <span>Instagram</span>
        </a>
        <a href="https://www.instagram.com/inmaculada_fuentes/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
          <img src="/instagram_icon2.webp" alt="Instagram" className="social-icon instagram-img" />
          <span>I.Fuentes</span>
        </a>
      </div>

      <div className="email-contact">
        <a href="mailto:i.fuentestomas@gmail.com" className="btn-primary email-btn">
          <span className="email-icon">✉</span>
          Enviar Email
        </a>
      </div>
    </section>
  );
}

export default ContactSection;